import { AuditWorkpaperSummary } from '../../Models/Api/strongbox.financialportal';

export enum AuditWorkpapersActions {
    LoadStart = 'AUDITWORKPAPERS/LoadStart',
    LoadComplete = 'AUDITWORKPAPERS/LoadComplete',
    LoadError = 'AUDITWORKPAPERS/LoadError',
}

export interface ILoadAuditWorkpapersStart {
    readonly type: AuditWorkpapersActions.LoadStart;
}

export interface ILoadAuditWorkpapersComplete {
    readonly type: AuditWorkpapersActions.LoadComplete;
    readonly workpapers: AuditWorkpaperSummary[];
}

export interface ILoadAuditWorkpapersError {
    readonly type: AuditWorkpapersActions.LoadError;
    readonly error: string;
}

export type KnownAction =
    ILoadAuditWorkpapersStart |
    ILoadAuditWorkpapersComplete |
    ILoadAuditWorkpapersError;
